import React from 'react'
import { getAllCategories } from '../../services/pub'
import { Breadcrumbs } from './components/Breadcrumbs'
import { AddItemButton } from './components/AddItemButton'
import BasicTable from '../../components/BasicTable'
import { useCookiesContext } from '../../contexts/CookiesContext'
import { cookiesKeyNames } from "@revbox/common-fe";

const colWidth = {
    name: 330,
    min_cpc: 200,
    url: 400,
    external_id: 200
}

const hiddenColumns = []

const rowFields = ['name', 'website_id', 'min_cpc', 'url', 'external_id']

export default function PublisherCategories() {
    const title = 'Categories'
    const breadcrumb = 'Inventory'
    const new_btn_title = 'New Category'
    const new_btn_redirect = '/pub/category/new'
    const edit_redirect = '/pub/category/edit'
    const { cookiesData, getPathKey } = useCookiesContext()

    const currentSkin = cookiesData[getPathKey()]?.[cookiesKeyNames.skinMode] === 'dark' ? 'dark' : ''

    return (
        <React.Fragment>
            <div className="main main-app d-flex flex-column p-3 p-lg-4">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <Breadcrumbs breadcrumb={breadcrumb} title={title} />
                    <AddItemButton new_btn_title={new_btn_title} new_btn_redirect={new_btn_redirect} />
                </div>

                <BasicTable
                    getData={getAllCategories}
                    url={edit_redirect}
                    hiddenColumns={hiddenColumns}
                    colWidth={colWidth}
                    rowFields={rowFields}
                    skin={currentSkin}
                />

                
            </div>
        </React.Fragment>
    )
}
